// Keep pricing copy in sync with checkout. Provider plan IDs and verification
// remain server-owned; display values must never authorize a payment.
export const INR_PRICING = {
  monthly: { price: 299, currency: '₹' },
  yearly: { price: 2999, currency: '₹', monthlyEquivalent: 249.92 },
};
export const USD_PRICING = {
  monthly: { price: 5.99, currency: '$' },
  yearly: { price: 59.99, currency: '$', monthlyEquivalent: 5.00 },
};

// Pricing region from the device time zone: rupee prices in India, US dollar prices everywhere
// else, all paid through Razorpay. A display-currency preference or a manual switch would let
// customers abroad choose the lower Indian price. An unknown time zone counts as India.
export const getPricingRegion = () => {
  let timeZone = '';
  try { timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch { /* unknown */ }
  return !timeZone || ['Asia/Kolkata', 'Asia/Calcutta'].includes(timeZone) ? 'india' : 'international';
};
export const getRegionalPricing = () => (getPricingRegion() === 'india' ? INR_PRICING : USD_PRICING);

// Pro in India is paid through Razorpay, which is waiting on SoapLab's own merchant account.
// Until then Indian visitors see "opening soon"; customers abroad pay through PayPal.
// Turn this on together with RAZORPAY_CHECKOUT_OPEN on the backend.
export const INDIA_PRO_AVAILABLE = false;
